import Image from '@pretto/bricks/website/shared/components/Image'

export default Image
